import React, { ReactNode } from "react";
import {Switch, withStyles} from "@material-ui/core";

interface ModalProps {
    show: boolean;
    onClose: () => void;
    title?: string;
    children?: ReactNode;
    width?: string;
    footer?: ReactNode;
    closeOnBackdropClick?: boolean;
    showToggle?: boolean;
    toggleChecked?: boolean;
    onToggleChange?: (checked: boolean) => void;
  toggleLabel?: string;
  height?:string;
  subText?: string;
  overflow?:string
  minHeight?:string
}

const CustomSwitch = withStyles({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: "#fff",
    "&$checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + $track": {
        backgroundColor: "#E5B42F",
        opacity: 1,
        border: "none",
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "0 1px 2px rgba(0,0,0,0.3)",
  },
  track: {
    borderRadius: 16 / 2,
    border: "1px solid #ccc",
    backgroundColor: "#ccc",
    opacity: 1,
    transition: "background-color 0.3s ease",
  },
  checked: {},
})(Switch);

const Modal: React.FC<ModalProps> = ({
    show,
    onClose,
    title,
    children,
    width = "500px",
    height,
    footer,
    closeOnBackdropClick = true,
                                       showToggle = false,
                                       toggleChecked = false,
                                       onToggleChange,
                                       toggleLabel = "Select ALL",
                                       subText,
                                       overflow,
                                       minHeight
}) => {
    if (!show) return null;

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (closeOnBackdropClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            onClick={handleBackdropClick}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: "8px",
                    padding: "25px",
                    width,
                  height,
                    position: "relative",
                  overflow:overflow?overflow:"auto",
                  minHeight:minHeight?minHeight:""
                }}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        background: "none",
                        border: "none",
                        fontSize: "20px",
                        color: "#999",
                        cursor: "pointer",
                    }}
                >
                    ×
                </button>
              <div style={{display:"flex",justifyContent:"space-between",margin:"1%" }}>
                <div>
                  {title && (
                    <h2
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 700,
                        fontSize: "12px",
                      }}
                    >
                      {title}
                    </h2>
                  )}
                  {subText && (
                    <p
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "100%",
                        letterSpacing: "0%",
                        margin: 0,
                        color: "#666",
                      }}
                    >
                      {subText}
                    </p>
                  )}
                </div>
                {/* Toggle Switch */}
                {showToggle && (
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 600,
                                fontFamily: "Poppins, sans-serif",
                              }}
                            >
                                {toggleLabel}
                            </span>

                    <CustomSwitch
                      checked={toggleChecked}
                      onChange={(e) =>
                        onToggleChange && onToggleChange(e.target.checked)
                      }
                    />
                  </div>
                )}
              </div>

                <div>{children}</div>
                {footer && <div style={{ marginTop: 20 }}>{footer}</div>}
            </div>
        </div>
    );
};

export default Modal;
